import { Routes } from '@angular/router';
import { PrivacyPolicyComponent } from './privacy-policy.component';

export const ModuleRoutes: Routes = [
    {
        path: '',
        component: PrivacyPolicyComponent
    }
]
